function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M45.484 47.9271C43.3054 52.543 49.0081 57.0559 52.1318 58.7354C53.4133 58.2483 61.5829 52.3962 58.8597 47.9271C56.553 44.3519 53.4069 46.0117 52.1318 47.2433C50.8236 45.6992 46.9415 44.8385 45.484 47.9271Z",
  fill: "#FA4364"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2193 45.1477C42.0408 49.7636 47.7435 54.2765 50.8671 55.9559C52.1486 55.4688 60.3182 49.6168 57.595 45.1477C55.2883 41.5725 52.1422 43.2323 50.8671 44.4639C49.5589 42.9198 45.6768 42.0591 44.2193 45.1477Z",
  stroke: "#26282C",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2193 45.1477C42.0408 49.7636 47.7435 54.2765 50.8671 55.9559C52.1486 55.4688 60.3182 49.6168 57.595 45.1477C55.2883 41.5725 52.1422 43.2323 50.8671 44.4639C49.5589 42.9198 45.6768 42.0591 44.2193 45.1477Z",
  stroke: "#26282C",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M61.9999 6.23535H36.647C34.4378 6.23535 32.647 8.02621 32.647 10.2354V19.7541C32.647 21.9632 34.4402 23.7541 36.6493 23.7541C38.8585 23.7541 40.6517 25.5449 40.6517 27.7541V31.8824C40.6517 34.0915 42.4425 35.8824 44.6517 35.8824H61.9999C64.2091 35.8824 65.9999 34.0915 65.9999 31.8824V10.2354C65.9999 8.02621 64.2091 6.23535 61.9999 6.23535Z",
  fill: "#FFC100"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7809 37.2684L4.62026 43.1391C4.22416 43.5166 4 44.0398 4 44.587V54.6299C4 55.2112 4.39741 56.7525 4.91503 57.2458C5.83007 58.1177 6.7451 58.1177 7.66013 58.1177H31.451C32.366 58.1177 33.6502 57.7106 34.1961 57.2458C34.8824 56.6614 34.8824 56.0414 34.8824 55.1694V49.616L27.8823 42.9454C27.1707 42.2673 26.0718 42.2068 25.2901 42.8028L22.931 44.6012C22.1174 45.2214 20.9669 45.1277 20.2645 44.3839L13.6147 37.343C12.8539 36.5374 11.5831 36.5039 10.7809 37.2684Z",
  fill: "#2C9358"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M37.353 26C37.353 26 40.1324 28.4706 44.7648 28.4706C49.3971 28.4706 52.1766 26 52.1766 26",
  stroke: "#131416",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.8236,
  cy: 18.5883,
  r: 2.47059,
  fill: "#131416"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 49.7059,
  cy: 18.5883,
  r: 2.47059,
  fill: "#131416"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M30 21.9545V10C30 7.79086 31.7909 6 34 6H57C59.2091 6 61 7.79086 61 10V33",
  stroke: "#131416",
  strokeWidth: 2.5
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 35.25,
  y: 33.25,
  width: 30.5,
  height: 32.5,
  rx: 2.75,
  stroke: "#131416",
  strokeWidth: 2.5
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M37 33.4286V26C37 23.7909 35.2091 22 33 22H10C7.79086 22 6 23.7909 6 26V40.8571V50C6 52.2091 7.79086 54 10 54H33.5556",
  stroke: "#131416",
  strokeWidth: 2.5
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M6 40L13.7333 32L22.4333 42L27.2667 38L35 46",
  stroke: "#131416",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 28,
  width: 5,
  height: 5,
  rx: 2.5,
  fill: "#131416"
});

function SvgEmptySelectionIcons(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySelectionIcons);
export default __webpack_public_path__ + "static/media/empty-selection-icons.f237bc51.svg";
export { ForwardRef as ReactComponent };